<template>
  <div class="flex items-start gap-2 text-sm text-gray-500" data-testid="ai-card-unsupported">
    <i class="pi pi-question-circle mt-0.5 text-gray-400"></i>
    <div>
      <p>{{ message }}</p>
      <p class="text-xs text-gray-400 mt-0.5">
        Type: <code class="font-mono">{{ type }}</code>
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { DECLARED_FUTURE_AI_CARD_TYPES } from './aiCardRegistry';

/**
 * Fallback for a component type this frontend has no renderer for. An
 * unrecognised type must degrade to this card, never break the workspace.
 */
const props = defineProps<{ type: string }>();

const isPlanned = computed(
  () => (DECLARED_FUTURE_AI_CARD_TYPES as readonly string[]).includes(props.type),
);

const message = computed(() =>
  isPlanned.value
    ? 'This view isn\'t supported in the workspace yet.'
    : 'This assistant can\'t display this item yet.');
</script>
